<div
  class="flex flex-col items-center justify-center h-screen bg-white dark:bg-gray-900 px-4"
>
  <div class="text-center">
    <h1
      class="text-[6rem] font-extrabold text-gray-900 dark:text-gray-100 leading-none"
    >
      404
    </h1>
    <p class="text-xl font-semibold text-gray-700 dark:text-gray-300 mt-2">
      Page Not Found
    </p>
    <p class="text-gray-500 dark:text-gray-400 mt-3 mb-6">
      The page you are looking for does not exist or has been moved.
    </p>

    <a
      class="inline-flex items-center px-6 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300"
      (click)="goHome()"
    >
      Go Back Home
      <svg
        class="w-4 h-4 ml-2 -mr-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 12h14m-7-7l7 7-7 7"
        />
      </svg>
    </a>
  </div>
</div>
